/* eslint-disable */
import React, { useEffect, useState } from "react";
import * as Styles from "./styles";
import Checkbox from "@mui/material/Checkbox";
import * as SVGIcons from "../../../../../../assets/iconsSVG";
import OutlookImage from "../../../../../../assets/images/outlookImage.png";
import moment from "moment";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

interface SharedWithProps {
  nomeCorretorDestino: string;
  dataCriacao: string;
  idCorretorDestinoSistemaOrigem: string;
  idLeadCompartilhado: string;
}

interface LeadProps {
  nomeLead: string;
  serialNumber: number;
  idLeadCorretorSistemaOrigem: string;
  idLeadSistemaOrigem: string;
  telefone: string;
  email: string;
  leadsCompartilhadosCom: SharedWithProps[];
}

interface Props {
  data: any;
  activeAll: boolean;
  checkedData: Array<string>;
  onItemSelect: (item: string) => void;
  allSelected: (item: string[], data: SharedWithProps[]) => void;
}

const SharedLeadItem: React.FC<Props> = ({
  data,
  activeAll,
  onItemSelect,
  checkedData,
  allSelected,
}) => {
  const [active, setActive] = React.useState(false);
  const [checkAll, setCheckAll] = useState<boolean>(false);

  const handleCheck = (item: SharedWithProps) => {
    if (item.idLeadCompartilhado !== undefined) {
      onItemSelect(item.idLeadCompartilhado);
    }
  };

  useEffect(() => {
    if (checkAll === true) {
      let array: string[] = [];
      data.leadsCompartilhadosCom.forEach((item: SharedWithProps) =>
        array.push(item.idLeadCompartilhado)
      );
      allSelected(array, data.leadsCompartilhadosCom);
    } else {
      const hasAllElems = data?.leadsCompartilhadosCom.every(
        (elem: SharedWithProps) =>
          checkedData.includes(elem.idLeadCompartilhado)
      );
      if (hasAllElems) {
        allSelected([], data.leadsCompartilhadosCom);
      }
    }
  }, [checkAll]);

  useEffect(() => {
    const hasAllElems = data?.leadsCompartilhadosCom.every(
      (elem: SharedWithProps) => checkedData.includes(elem.idLeadCompartilhado)
    );
    setCheckAll(hasAllElems);
  }, [checkedData]);

  const formatPhoneNumber = (str: string) => {
    const match: any =
      str.match(/^(\d{2})(\d{2})(\d{5})(\d{4})$/) ||
      str.match(/^(\d{2})(\d{2})(\d{4})(\d{4})$/) ||
      str.match(/^(\d{3})(\d{3})(\d{3})(\d{3})(\d{3})$/) ||
      str.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/) ||
      str.match(/^(\d{2})(\d{3})(\d{3})(\d{3})(\d{1})$/);

    if (match && match.length <= 5) {
      return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
    }
    if (match && match.length > 5) {
      return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}-${match[5]}`;
    }

    return str;
  };

  return (
    <Styles.Container>
      <Styles.MainRow>
        <Styles.RowSpace>
          <Styles.ColumnFull>
            <Styles.Row>
              <Checkbox
                checked={checkAll}
                onChange={() => setCheckAll(!checkAll)}
                {...label}
              />
              <Styles.Text>
                {data.nomeLead} - {data.serialNumber}
              </Styles.Text>
            </Styles.Row>
          </Styles.ColumnFull>

          <Styles.Column>
            <Styles.Row>
              <Styles.Row>
                <SVGIcons.WhatsappIcon style={{ marginRight: 8 }} />
                <Styles.Text>
                  {data?.telefone ? formatPhoneNumber(data?.telefone) : "--"}
                </Styles.Text>
              </Styles.Row>
              <Styles.SpaceX space={16} />
              <Styles.Row>
                <img
                  src={OutlookImage}
                  alt=""
                  style={{ width: 20, height: 20, marginRight: 12 }}
                />
                <Styles.Text>{data?.email ? data?.email : "--"}</Styles.Text>
              </Styles.Row>
            </Styles.Row>
          </Styles.Column>
        </Styles.RowSpace>
      </Styles.MainRow>
      <Styles.Line />
      <Styles.SharedContainer>
        <Styles.Title>Compartilhado com</Styles.Title>
        {data?.leadsCompartilhadosCom?.map(
          (item: SharedWithProps, index: number) => (
            <>
              <Styles.SharedItem key={index}>
                <Styles.Row>
                  <Checkbox
                    value={item?.idLeadCompartilhado}
                    checked={checkedData.includes(item.idLeadCompartilhado)}
                    onChange={() => handleCheck(item)}
                    {...label}
                  />
                  <Styles.Title>{item?.nomeCorretorDestino}</Styles.Title>
                </Styles.Row>

                <Styles.Title>
                  Compartilhado em:{" "}
                  {moment(item?.dataCriacao).format("DD/MM/YYYY")}
                </Styles.Title>
              </Styles.SharedItem>
            </>
          )
        )}
      </Styles.SharedContainer>
    </Styles.Container>
  );
};

export default SharedLeadItem;
